<template>
    <div class="tab" :class="{ 'tab-two': tabs.length === 2 }">
        <div :class="tabsClass">
            <div v-if="isSmartphoneLarge && !onlyTwoTabs" class="tab__mobile-dropdown" @click="toggleDropdown">
                <button :ref="activeTabData?.name" class="tab__mobile-selector">
                    <span class="tab__name">
                        <template v-if="activeTabData?.icon">
                            <common-icon
                                :class="`icon-${activeTabData?.icon}`"
                                :name="activeTabData?.icon"
                                size="huge"
                            ></common-icon>
                            &nbsp;
                        </template>

                        <span class="tab__label">{{ activeTabData?.displayName || activeTabData?.name }}</span>
                    </span>
                </button>

                <div v-if="!onlyOneTab" class="tab__dropdown-arrow">
                    <common-icon :name="areTabsOpen ? 'close-black' : 'arrow-down'" size="medium"></common-icon>
                </div>
            </div>

            <button
                v-for="(tab, tabIndex) in tabs"
                v-show="!isSmartphoneLarge || (isSmartphoneLarge && !onlyTwoTabs && tab.name !== selectedTab) || onlyTwoTabs"
                :key="tabIndex"
                :ref="tab.name"
                :class="tabClass(tab, tabIndex)"
                @click="tabClicked(tab.name)"
                @mouseover="tabMouseOver(tab.name)"
                @mouseleave="tabMouseLeave(tab.name)"
            >
                <div class="tab__name">
                    <div v-if="tab.icon">
                        <common-icon :class="`icon-${tab.icon}`" :name="tab.icon" size="huge"></common-icon>
                        &nbsp;
                    </div>

                    <div class="tab__label">{{ tab.displayName || tab.name }}</div>
                </div>
            </button>
        </div>
        <div :class="tabContentClass">
            <slot :name="selectedTab"></slot>
        </div>
    </div>
</template>

<script>
    import WindowResizeMixin from 'mixins/WindowResizeMixin'

    export default {
        mixins: [WindowResizeMixin],
        props: {
            tabs: { type: Array, required: true, validator: (arr) => !!arr && arr.length },
            activeTab: { type: String, required: true },
        },

        data() {
            return {
                selectedTab: this.activeTab,
                areTabsOpen: false,
            }
        },

        computed: {
            tabContentClass() {
                return {
                    tab__content: true,
                    'tab__content--with-padding': this.activeTabData?.withPadding,
                }
            },

            isTabsMobileDropdownClosed() {
                return !this.areTabsOpen && this.isSmartphoneLarge
            },

            tabsClass() {
                return {
                    tab__tabs: true,
                    'tab__tabs--closed': this.isTabsMobileDropdownClosed && !this.onlyTwoTabs,
                    'tab__tabs--two': this.onlyTwoTabs,
                    'tab__tabs--mobile': !this.onlyTwoTabs && this.areTabsOpen && this.isSmartphoneLarge,
                }
            },

            onlyTwoTabs() {
                return this.tabs.length === 2
            },

            onlyOneTab() {
                return this.tabs.length === 1
            },

            activeTabData() {
                return this.tabs.find((tab) => tab.name === this.selectedTab)
            },
        },

        methods: {
            tabClicked(tabName) {
                this.selectedTab = tabName
                this.areTabsOpen = false
                this.emitEvent({ name: 'tab-click', payload: tabName })
                window.scrollTo(0, 0)
            },

            tabMouseOver(tabName) {
                if (this.selectedTab !== tabName) {
                    this.$refs[this.selectedTab]?.classList?.add('tab__tablink--mouseover')
                    this.$refs[tabName]?.classList?.add('tab__tablink--hover')
                }
            },

            tabMouseLeave(tabName) {
                if (this.selectedTab !== tabName) {
                    this.$refs[this.selectedTab].classList?.remove('tab__tablink--mouseover')
                    this.$refs[tabName].classList?.remove('tab__tablink--hover')
                }
            },

            tabClass(tab, tabIndex) {
                return {
                    tab__tablink: true,
                    'tab__tablink--active': this.selectedTab === tab.name,
                    'tab__tablink--active__first': tabIndex === 0,
                    'tab__tablink--hidden': tab.hidden,
                    'tab__tablink--two': this.onlyTwoTabs,
                }
            },

            toggleDropdown() {
                this.areTabsOpen = !this.areTabsOpen
            },
        },

        watch: {
            selectedTab(newValue, oldValue) {
                this.$refs[newValue]?.classList?.add('tab__tablink--active')
                this.$refs[newValue]?.classList?.remove('tab__tablink--hover')

                this.$refs[oldValue]?.classList?.remove('tab__tablink--active')
                this.$refs[oldValue]?.classList?.remove('tab__tablink--mouseover')

                this.emitEvent({ name: 'tab-change', payload: newValue })
            },
        },
    }
</script>
